export const DEFAULT_CONFIDENCE = 0.9;
